<template>
  <div class="sr-property">
    <div class="gallery">
      <sr-thumb-zoom :list="DATA.img" :path="true"/>
    </div>
    <div class="wrap">
      <p class="brand">{{DATA.brandNameEn}} / {{DATA.brandName}}</p>
      <p class="name">{{DATA.name}}</p>
      <p class="productTitle">{{DATA.productTitle}}</p>
      <p class="basicPrice">市场价：{{DATA.basicPrice | money}}</p>
      <p class="currentPrice">耀莱在线价格：<span>{{DATA.currentPrice | money}}</span></p>
      <p class="calculateCoinByProduct">购物即赠送 {{DATA.calculateCoinByProduct | money}} 金币</p>
      <p class="reminder" v-if="DATA.reminde">温馨提示：{{DATA.reminder}}</p>
      <p class="buy" @click="buy(DATA.uuid)">立即购买</p>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="300px">
       <div class="dialog-con">
        <p>微信扫一扫，立即购买</p>
        <p>{{DATA.name}}</p>
        <sr-qr-code :text="qrCodeText"/>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import SrThumbZoom from '@/components/thumb-zoom'
  import SrQrCode from '@/components/QRCode'
  export default {
    components: {
      SrThumbZoom,
      SrQrCode
    },
    props: {
      data: Object
    },
    data () {
      return {
        DATA: this.data,
        thumb: [],
        dialogVisible: false,
        qrCodeText: ''
      }
    },
    methods: {
      buy (v) {
        this.dialogVisible = true
        this.qrCodeText = 'https://m2.ylzxvip.com/luxury/#/luxury-goods-detail/' + v
      }
    }
  }
</script>

<style lang="less" scoped>
  .sr-property {
    overflow: hidden;
    padding: 30px 0;
    .gallery {
      float: left;
      width: 684px;
      overflow: hidden;
      .thumb {
        float: left;
        height: 510px;
        overflow: hidden;
        li {
          width: 160px;
          height: 160px;
          margin-bottom: 12px;
          border: 1px solid #eee;
          cursor: pointer;
        }
        .cur {
          border: 1px solid #cdad66;
        }
      }
      .thumbZoom {
        float: right;
        width: 508px;
        height: 508px;
        border: 1px solid #eee;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
    .wrap {
      float: right;
      width: 460px;
      .brand {
        color: #333;
      }
      .brand {
        padding-top: 10px;
      }
      .name {
        padding: 10px 0;
        font-size: 20px;
        font-weight: bold;
        color: #333;
      }
      .productTitle {
        padding-bottom: 10px;
      }
      .basicPrice {
        color: #b2b2b2;
        text-decoration: line-through;
      }
      .currentPrice {
        color: #333;
        span {
          color: #cdad66;
          font-weight: bold;
        }
      }
      .calculateCoinByProduct {
        padding-top: 10px;
        color: #cdad66;
      }
      .reminder {
        padding-top: 10px;
      }
      .buy {
        width: 150px;
        line-height: 36px;
        margin-top: 10px;
        border-radius: 3px;
        background-color: #cdad66;
        text-align: center;
        color: white;
        cursor: pointer;
        &:hover {
          background-color: #bc9c55;
        }
      }
    }
    .dialog-con {
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/list-detail/sr-top.vue